import { h } from 'preact'
import Switcher from '../control/Switcher'
import {
  ActionButtons,
  HowToTextWithOpenInNewTabIcon,
  InformationCallout,
  RegistrationRulesPanelHeader
} from '../registration-rules/PanelItems'

interface BodyProps {
    isModeratorApprovalEnabled: boolean,
    showActionButtons: boolean,
    onSave: () => void,
    onCancel: () => void,
    onModeratorApprovalChanged: (value: boolean) => void
}

export const ModeratorApprovalPanelBody = ({ isModeratorApprovalEnabled, showActionButtons, onSave, onCancel, onModeratorApprovalChanged } : BodyProps) => (
  <div className='panel-body-container'>
    <InformationCallout text='Users with the following roles are excluded from this control: Administrator, Community Manager, Moderator, Superuser.' />
    <div>
      <Switcher
        on={isModeratorApprovalEnabled}
        customClass='panel-switch moderator-approval-panel'
        label={<LabelWithLinkInText />}
        onChange={() => onModeratorApprovalChanged(!isModeratorApprovalEnabled)} />
    </div>
    <HowToTextWithOpenInNewTabIcon
      label='How to review and approve new posts'
      url='https://community.insided.com/moderating-content-79/how-to-enable-moderator-approval-of-posts-by-new-users-469' />
    { showActionButtons &&
    <ActionButtons
      onSave={() => onSave()}
      onCancel={() => onCancel()} />
    }
  </div>
)

export const LabelWithLinkInText = () => (
  <div> All new topics and replies from users will be sent to <a className='panel-switch-label-link' href='/moderation/pending' target='_blank'>Pending</a>. These topics and replies will only be visible on the community after moderator approval.</div>
)

interface HeaderProps {
    statusText: string
}

export const ModeratorApprovalPanelHeader = ({ statusText } : HeaderProps) => (
  <RegistrationRulesPanelHeader
    customClass='panel-header-container'
    iconCustomClass='icon-panel-header'
    icon='moderatorApproval'
    title='Moderator approval of new topics and replies'
    statusText={statusText} />
)
